import React, { useState, useRef, useEffect } from "react";
import {
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardArrowLeft,
} from "react-icons/md";

const Sortlist = () => {
  const sortItems = [
    "Top",
    "Trending",
    "Most Visited",
    "New",
    "Gainers",
    "Real-World Assets",
  ];

  // ✅ load from localStorage
  const [active, setActive] = useState(
    () => localStorage.getItem("activeSortItem") || sortItems[0]
  );

  const scrollRef = useRef(null);

  // ✅ save to localStorage whenever active changes
  useEffect(() => {
    localStorage.setItem("activeSortItem", active);
  }, [active]);

  const scrollRight = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  const scrollLeft = () => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  return (
    <div
      ref={scrollRef}
      className="w-full border-b border-gray-900 overflow-x-auto no-scrollbar items-center flex"
    >
      <span
        onClick={scrollRight}
        className="border  bg-gray-700 md:hidden -translate-y-1/2 z-10 outline-none focus:outline-none text-gray-500 text-xl flex justify-center items-center border-gray-900 w-5 h-5 rounded-full absolute right-0 mr-2"
      >
        <MdOutlineKeyboardArrowRight />
      </span>

      <span
        onClick={scrollLeft}
        className="border md:hidden outline-none bg-gray-700 focus:outline-none text-gray-500 text-xl flex justify-center items-center border-gray-900 w-5 h-5 rounded-full absolute left-0 ml-2"
      >
        <MdOutlineKeyboardArrowLeft />
      </span>

      <div className="inline-flex md:ml-20 items-center md:gap-16 md:px-4 px-8">
        {sortItems.map((item, index) => (
          <a
            onClick={() => setActive(item)} // ✅ persists
            key={index}
            href="/"
            className={`flex justify-center items-center transition-all duration-300 ease-in-out text-base ${
              active === item
                ? "border-blue-500 border-b-2"
                : "border border-transparent "
            } py-4 outline-none focus:outline-none font-medium shrink-0 w-40 md:w-auto md:text-xl text-gray-600 whitespace-nowrap`}
          >
            {item}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Sortlist;
